import { Loader } from "https://cdn.jsdelivr.net/npm/@googlemaps/js-api-loader@latest/dist/index.esm.js";

const map1El = document.getElementById("map-canvas"),
    map2El = document.getElementById("map-canvas2");
let loaded = false;

const mapId = "3fa62ca3ac95ef0d66628611";

function initMaps() {
    [
        { el: map1El, pos: { lat: 59.339896, lng: 18.089797 }, title: "Peach Stockholm Östermalm" },
        { el: map2El, pos: { lat: 59.34526,  lng: 18.040172 }, title: "Peach Stockholm Vasastan" }
    ].forEach(({ el, pos, title }) => {
        const map = new google.maps.Map(el, {
            zoom:       15,
            center:     pos,
            mapTypeId:  google.maps.MapTypeId.ROADMAP,
            mapId:      mapId
        });
        new google.maps.marker.AdvancedMarkerElement({ position: pos, map, title });
    });
}

(function() {
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.run();
            obs.unobserve(entry.target);
        });
    }, {
        rootMargin: "0px 0px 650px 0px",
        threshold:  0
    });

    function loadMaps() {
        if (loaded) return;
        loaded = true;
        new Loader({
            apiKey:    "AIzaSyAti5v3n4cbynkUxjJvlytNa1u4ySi4tL8",
            version:   "weekly",
            libraries: ["marker"],
            mapIds:    [mapId]
        }).load().then(initMaps);
    }

    map1El.run = loadMaps;
    observer.observe(map1El);
})();
